export default(
[
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/134235826/alfaomega/small_logo201707251117.jpg",
    "name": "Alfaomega",
    "url": "https://tienda.mercadolibre.cl/alfaomega"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/313718012/allnutrition/small_logo201809050135.jpg",
    "name": "All Nutrition",
    "url": "https://tienda.mercadolibre.cl/all-nutrition"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/270694584/alpinestars/small_logo201708280442.jpg",
    "name": "Alpinestars",
    "url": "https://tienda.mercadolibre.cl/alpinestars"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/176035007/alteclansing/small_logo201808290919.jpg",
    "name": "Altec Lansing",
    "url": "https://tienda.mercadolibre.cl/altec-lansing"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/114674801/anker/small_logo201705080409.jpg",
    "name": "Anker",
    "url": "https://tienda.mercadolibre.cl/anker"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/238578600/aoc/small_logo201705241139.jpg",
    "name": "AOC",
    "url": "https://tienda.mercadolibre.cl/aoc"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/211076262/assistcard/small_logo201610190444.jpg",
    "name": "Assist Card",
    "url": "https://tienda.mercadolibre.cl/assist-card"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/204808902/avent/small_logo201607140232.jpg",
    "name": "Avent",
    "url": "https://tienda.mercadolibre.cl/avent"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/234945806/babyinfanti/small_logo201701111153.jpg",
    "name": "Baby Infanti",
    "url": "https://tienda.mercadolibre.cl/baby-infanti"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/311050127/babyway/small_logo201804120512.jpg",
    "name": "Baby Way",
    "url": "https://tienda.mercadolibre.cl/baby-way"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/344373719/babycenter/small_logo201808241026.jpg",
    "name": "Babycenter",
    "url": "https://tienda.mercadolibre.cl/babycenter"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/315984133/babysec/small_logo201808061249.jpg",
    "name": "Babysec",
    "url": "https://tienda.mercadolibre.cl/babysec"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/329266172/babytuto/small_logo201807061110.jpg",
    "name": "Babytuto",
    "url": "https://tienda.mercadolibre.cl/babytuto"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/277034962/bamers/small_logo201710060311.jpg",
    "name": "Bamers",
    "url": "https://tienda.mercadolibre.cl/bamers"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/274269458/bata/small_logo201710260502.jpg",
    "name": "Bata",
    "url": "https://tienda.mercadolibre.cl/bata"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/322297798/bebeglo/small_logo201805250325.jpg",
    "name": "Bebeglo",
    "url": "https://tienda.mercadolibre.cl/bebeglo"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/324636796/bebesit/small_logo201806050256.jpg",
    "name": "Bebesit",
    "url": "https://tienda.mercadolibre.cl/bebesit"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/212576261/bell/small_logo201607220300.jpg",
    "name": "Bell",
    "url": "https://tienda.mercadolibre.cl/bell"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/182336014/bestway/small_logo201508190446.jpg",
    "name": "Bestway",
    "url": "https://tienda.mercadolibre.cl/bestway"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/212576261/bianchi/small_logo201709210959.jpg",
    "name": "Bianchi",
    "url": "https://tienda.mercadolibre.cl/bianchi"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/170130005/blackdeckertools/small_logo201709111140.jpg",
    "name": "Black&Decker Tools",
    "url": "https://tienda.mercadolibre.cl/blackdecker-tools"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/226369160/blackdeckerhome/small_logo201612020455.jpg",
    "name": "Black+Decker Home",
    "url": "https://tienda.mercadolibre.cl/black-decker-home"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/303443508/block/small_logo201802270522.jpg",
    "name": "Block",
    "url": "https://tienda.mercadolibre.cl/block"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/220234602/blu/small_logo201607260855.jpg",
    "name": "BLU",
    "url": "https://tienda.mercadolibre.cl/blu"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/176035007/bolle/small_logo201806180613.jpg",
    "name": "Bolle",
    "url": "https://tienda.mercadolibre.cl/bolle"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/135526618/bolomey/small_logo201606031055.png",
    "name": "Bolomey",
    "url": "https://tienda.mercadolibre.cl/bolomey"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/293481817/bosca/small_logo201805150320.jpg",
    "name": "Bosca",
    "url": "https://tienda.mercadolibre.cl/bosca"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/216522279/boschtools/small_logo201609070451.jpg",
    "name": "Bosch Tools",
    "url": "https://tienda.mercadolibre.cl/bosch-tools"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/256952732/braun/small_logo201712110347.jpg",
    "name": "Braun",
    "url": "https://tienda.mercadolibre.cl/braun"
  },
  {
    "logo": "https://http2.mlstatic.com/static/org-img/apparel/images/buscalibre/161132877-logo-ch.png",
    "name": "Buscalibre",
    "url": "https://tienda.mercadolibre.cl/buscalibre"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/266727594/buzzrack/small_logo201708040536.jpg",
    "name": "BuzzRack",
    "url": "https://tienda.mercadolibre.cl/buzzrack"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/200030355/capilatis/small_logo201709060127.jpg",
    "name": "Capilatis",
    "url": "https://tienda.mercadolibre.cl/capilatis"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/243583297/casaroyal/small_logo201704261033.jpg",
    "name": "Casa Royal",
    "url": "https://tienda.mercadolibre.cl/casa-royal"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/270611033/cav/small_logo201806271258.jpg",
    "name": "CAV",
    "url": "https://tienda.mercadolibre.cl/cav"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/211712107/celestron/small_logo201604210222.png",
    "name": "Celestron",
    "url": "https://tienda.mercadolibre.cl/celestron"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/287701675/celta/small_logo201711300144.jpg",
    "name": "Celta",
    "url": "https://tienda.mercadolibre.cl/celta"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/234020429/chc/small_logo201712290110.jpg",
    "name": "CHC",
    "url": "https://tienda.mercadolibre.cl/chc"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/157017441/chefworks/small_logo201706200450.jpg",
    "name": "Chef Works",
    "url": "https://tienda.mercadolibre.cl/chef-works"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/115637139/chevrolet/small_logo201808140622.jpg",
    "name": "Chevrolet",
    "url": "https://tienda.mercadolibre.cl/chevrolet"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/316471956/chicfrance/small_logo201808070257.jpg",
    "name": "Chic France",
    "url": "https://tienda.mercadolibre.cl/chic-france"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/235754877/chilemat/small_logo201612070248.jpg",
    "name": "Chilemat",
    "url": "https://tienda.mercadolibre.cl/chilemat"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/260740392/cic/small_logo201711270903.jpg",
    "name": "CIC",
    "url": "https://tienda.mercadolibre.cl/cic"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/214250609/cintegral/small_logo201709211002.jpg",
    "name": "CIntegral",
    "url": "https://tienda.mercadolibre.cl/cintegral"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/217505829/combi/small_logo201703240220.jpg",
    "name": "Combi",
    "url": "https://tienda.mercadolibre.cl/combi"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/238578600/conair/small_logo201701031145.jpg",
    "name": "Conair",
    "url": "https://tienda.mercadolibre.cl/conair"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/315984133/confort/small_logo201808060519.jpg",
    "name": "Confort",
    "url": "https://tienda.mercadolibre.cl/confort"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/305373028/corona/small_logo201803190900.jpg",
    "name": "Corona",
    "url": "https://tienda.mercadolibre.cl/corona"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/256901399/corsair/small_logo201806200326.jpg",
    "name": "Corsair",
    "url": "https://tienda.mercadolibre.cl/corsair"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/315984133/cotidian/small_logo201805150405.jpg",
    "name": "Cotidian",
    "url": "https://tienda.mercadolibre.cl/cotidian"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/238578600/cuisinart/small_logo201612280402.jpg",
    "name": "Cuisinart",
    "url": "https://tienda.mercadolibre.cl/cuisinart"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/225126657/cybex/small_logo201804020930.jpg",
    "name": "Cybex",
    "url": "https://tienda.mercadolibre.cl/cybex"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/225778595/daewoo/small_logo201712180509.jpg",
    "name": "Daewoo",
    "url": "https://tienda.mercadolibre.cl/daewoo"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/225778595/delonghi/small_logo201809110749.jpg",
    "name": "DeLonghi",
    "url": "https://tienda.mercadolibre.cl/delonghi"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/231203071/desafiolevantemoschile/small_logo201611040931.jpg",
    "name": "Desafio Levantemos Chile",
    "url": "https://tienda.mercadolibre.cl/desafio-levantemos-chile"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/170130005/dewalt/small_logo201611160452.jpg",
    "name": "Dewalt",
    "url": "https://tienda.mercadolibre.cl/dewalt"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/335874586/dijon/small_logo201808071208.jpg",
    "name": "Dijon",
    "url": "https://tienda.mercadolibre.cl/dijon"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/185876509/dimarsa/small_logo201708010346.jpg",
    "name": "Dimarsa",
    "url": "https://tienda.mercadolibre.cl/dimarsa"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/294848523/dji/small_logo201806270253.jpg",
    "name": "DJI",
    "url": "https://tienda.mercadolibre.cl/dji"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/289837075/doce34/small_logo201808271055.jpg",
    "name": "Doce34",
    "url": "https://tienda.mercadolibre.cl/doce34"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/216522279/dremel/small_logo201609140218.jpg",
    "name": "Dremel",
    "url": "https://tienda.mercadolibre.cl/dremel"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/210975197/drimkip/small_logo201808220102.jpg",
    "name": "Drimkip",
    "url": "https://tienda.mercadolibre.cl/drimkip"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/231203596/duracell/small_logo201803271046.jpg",
    "name": "Duracell",
    "url": "https://tienda.mercadolibre.cl/duracell"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/222517911/ebayselection/small_logo201703130130.jpg",
    "name": "eBay",
    "url": "https://tienda.mercadolibre.cl/ebay"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/279658800/einhell/small_logo201806070700.jpg",
    "name": "Einhell",
    "url": "https://tienda.mercadolibre.cl/einhell"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/284500286/electrolux/small_logo201711270543.jpg",
    "name": "Electrolux",
    "url": "https://tienda.mercadolibre.cl/electrolux"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/315984133/elite/small_logo201808060530.jpg",
    "name": "Elite",
    "url": "https://tienda.mercadolibre.cl/elite"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/316471956/enersocks/small_logo201808061228.jpg",
    "name": "Enersocks",
    "url": "https://tienda.mercadolibre.cl/enersocks"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/195528355/farmaciamapuche/small_logo201709131138.jpg",
    "name": "Farmacia Mapuche",
    "url": "https://tienda.mercadolibre.cl/farmacia-mapuche"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/325982945/fensa/small_logo201806110305.jpg",
    "name": "Fensa",
    "url": "https://tienda.mercadolibre.cl/fensa"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/256912376/ferreteraoviedo/small_logo201710050237.jpg",
    "name": "Ferretería Oviedo",
    "url": "https://tienda.mercadolibre.cl/ferreteria-oviedo"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/278115375/festinagroup/small_logo201807300553.jpg",
    "name": "Festina Group",
    "url": "https://tienda.mercadolibre.cl/festina-group"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/294848523/fiddler/small_logo201806270926.jpg",
    "name": "Fiddler",
    "url": "https://tienda.mercadolibre.cl/fiddler"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/173205249/flex/small_logo201611020151.jpg",
    "name": "Flex",
    "url": "https://tienda.mercadolibre.cl/flex"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/215507138/fordtools/small_logo201709220408.jpg",
    "name": "Ford Tools",
    "url": "https://tienda.mercadolibre.cl/ford-tools"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/289837075/fossilgroup/small_logo201808271046.jpg",
    "name": "Fossil Group",
    "url": "https://tienda.mercadolibre.cl/fossil-group"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/161060078/fullbikes/small_logo201807090601.jpg",
    "name": "Full Bikes",
    "url": "https://tienda.mercadolibre.cl/full-bikes"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/289837075/gshock/small_logo201808271057.jpg",
    "name": "G-Shock",
    "url": "https://tienda.mercadolibre.cl/gshock"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/256952732/gama/small_logo201705241025.jpg",
    "name": "Gama",
    "url": "https://tienda.mercadolibre.cl/gama"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/176035007/gangsta/small_logo201806191107.jpg",
    "name": "Gangsta",
    "url": "https://tienda.mercadolibre.cl/gangsta"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/309649153/genius/small_logo201804121003.jpg",
    "name": "Genius",
    "url": "https://tienda.mercadolibre.cl/genius"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/176035007/gopro/small_logo201501300500.jpg",
    "name": "GoPro",
    "url": "https://tienda.mercadolibre.cl/gopro"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/271730605/guante/small_logo201805101153.jpg",
    "name": "Guante",
    "url": "https://tienda.mercadolibre.cl/guante"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/276252002/guesswatches/small_logo201806221102.jpg",
    "name": "Guess Watches",
    "url": "https://tienda.mercadolibre.cl/guess-watches"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/285876982/hakahonu/small_logo201801180222.jpg",
    "name": "Haka Honu",
    "url": "https://tienda.mercadolibre.cl/haka-honu"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/301312883/hasbro/small_logo201803130209.jpg",
    "name": "Hasbro",
    "url": "https://tienda.mercadolibre.cl/hasbro"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/228531702/heimat/small_logo201803221218.jpg",
    "name": "Heimat",
    "url": "https://tienda.mercadolibre.cl/heimat"
  },
  {
    "logo": "https://http2.mlstatic.com/static/org-img/apparel/images/hp/178972090-logo-ch4.jpg",
    "name": "HP",
    "url": "https://tienda.mercadolibre.cl/hp"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/301258112/huawei/small_logo201806200403.jpg",
    "name": "Huawei",
    "url": "https://tienda.mercadolibre.cl/huawei"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/238578600/kingston/small_logo201807231233.jpg",
    "name": "HyperX",
    "url": "https://tienda.mercadolibre.cl/hyperx"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/346533749/ibikes/small_logo201809261126.jpg",
    "name": "Ibikes",
    "url": "https://tienda.mercadolibre.cl/ibikes"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/208890962/ilko/small_logo201711280325.jpg",
    "name": "Ilko",
    "url": "https://tienda.mercadolibre.cl/ilko"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/295543881/implementosepysa/small_logo201801221016.jpg",
    "name": "Implementos Epysa",
    "url": "https://tienda.mercadolibre.cl/implementos-epysa"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/352468945/ingco/small_logo201809260405.jpg",
    "name": "INGCO",
    "url": "https://tienda.mercadolibre.cl/ingco"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/266121174/intersport/small_logo201803210930.jpg",
    "name": "Intersport",
    "url": "https://tienda.mercadolibre.cl/intersport"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/175064633/irobot/small_logo201708041236.jpg",
    "name": "IRobot",
    "url": "https://tienda.mercadolibre.cl/irobot"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/256901399/jbl/small_logo201707310954.jpg",
    "name": "JBL",
    "url": "https://tienda.mercadolibre.cl/jbl"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/153042887/kaltemp/small_logo201708280502.jpg",
    "name": "Kaltemp",
    "url": "https://tienda.mercadolibre.cl/kaltemp"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/330197381/karcher/small_logo201807051245.jpg",
    "name": "Karcher",
    "url": "https://tienda.mercadolibre.cl/karcher"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/228531702/kendal/small_logo201610061251.jpg",
    "name": "Kendal",
    "url": "https://tienda.mercadolibre.cl/kendal"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/62132161/kidscool/small_logo201608230141.jpg",
    "name": "Kidscool",
    "url": "https://tienda.mercadolibre.cl/kidscool"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/236292130/kingston/small_logo201807300551.jpg",
    "name": "Kingston",
    "url": "https://tienda.mercadolibre.cl/kingston"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/236416659/lapolar/small_logo201701041014.jpg",
    "name": "La Polar",
    "url": "https://tienda.mercadolibre.cl/la-polar"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/315984133/ladysoft/small_logo201808060533.jpg",
    "name": "Ladysoft",
    "url": "https://tienda.mercadolibre.cl/ladysoft"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/212576261/lahsen/small_logo201607250529.jpg",
    "name": "Lahsen",
    "url": "https://tienda.mercadolibre.cl/lahsen"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/234945806/lego/small_logo201710310346.jpg",
    "name": "Lego",
    "url": "https://tienda.mercadolibre.cl/lego"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/340180013/lg/small_logo201808301216.jpg",
    "name": "LG",
    "url": "https://tienda.mercadolibre.cl/lg"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/333923696/libreranacional/small_logo201807311100.jpg",
    "name": "Librería Nacional",
    "url": "https://tienda.mercadolibre.cl/libreria-nacional"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/285876982/lippi/small_logo201711230326.jpg",
    "name": "Lippi",
    "url": "https://tienda.mercadolibre.cl/lippi"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/256952732/littletikes/small_logo201709210952.jpg",
    "name": "Little Tikes",
    "url": "https://tienda.mercadolibre.cl/little-tikes"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/189965730/llantasdelpacifico/small_logo201708010716.jpg",
    "name": "Llantas del pacifico",
    "url": "https://tienda.mercadolibre.cl/llantas-del-pacifico"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/225778595/logitech/small_logo201708080417.jpg",
    "name": "Logitech",
    "url": "https://tienda.mercadolibre.cl/logitech"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/320443822/ls2/small_logo201806190737.jpg",
    "name": "LS2",
    "url": "https://tienda.mercadolibre.cl/ls2"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/315168851/loralprofessionnel/small_logo201806151209.jpg",
    "name": "L´Oréal Professionnel",
    "url": "https://tienda.mercadolibre.cl/loreal-professionnel"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/255597441/maam/small_logo201710310520.jpg",
    "name": "Maam",
    "url": "https://tienda.mercadolibre.cl/maam"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/312087127/mabe/small_logo201804040208.jpg",
    "name": "Mabe",
    "url": "https://tienda.mercadolibre.cl/mabe"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/325982945/mademsa/small_logo201806110316.jpg",
    "name": "Mademsa",
    "url": "https://tienda.mercadolibre.cl/mademsa"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/296608135/magasa/small_logo201803120952.jpg",
    "name": "Magasa",
    "url": "https://tienda.mercadolibre.cl/magasa"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/241232759/manfrotto/small_logo201705020428.png",
    "name": "Manfrotto",
    "url": "https://tienda.mercadolibre.cl/manfrotto"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/269961502/maxell/small_logo201708230453.jpg",
    "name": "Maxell",
    "url": "https://tienda.mercadolibre.cl/maxell"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/272215808/melissadoug/small_logo201709260244.jpg",
    "name": "Melissa & Doug",
    "url": "https://tienda.mercadolibre.cl/melissa--doug"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/262198016/microplay/small_logo201806150331.jpg",
    "name": "Microplay",
    "url": "https://tienda.mercadolibre.cl/microplay"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/236292130/mobilehut/small_logo201708010439.jpg",
    "name": "MobileHUT",
    "url": "https://tienda.mercadolibre.cl/mobilehut"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/280018363/momo/small_logo201711070313.jpg",
    "name": "MOMO",
    "url": "https://tienda.mercadolibre.cl/momo"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/277052057/monroe/small_logo201710101138.jpg",
    "name": "Monroe",
    "url": "https://tienda.mercadolibre.cl/monroe"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/236292130/motorola/small_logo201807100650.jpg",
    "name": "Motorola",
    "url": "https://tienda.mercadolibre.cl/motorola"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/271947391/mowstore/small_logo201710050435.jpg",
    "name": "MOWSTORE",
    "url": "https://tienda.mercadolibre.cl/mowstore"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/256901399/msi/small_logo201802270316.jpg",
    "name": "MSI",
    "url": "https://tienda.mercadolibre.cl/msi"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/178617398/mtek/small_logo201709121009.jpg",
    "name": "Mtek",
    "url": "https://tienda.mercadolibre.cl/mtek"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/237931934/musicworld/small_logo201704120952.jpg",
    "name": "Music World",
    "url": "https://tienda.mercadolibre.cl/music-world"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/182336014/nationalgeographic/small_logo201508181100.jpg",
    "name": "National Geographic",
    "url": "https://tienda.mercadolibre.cl/national-geographic"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/226369160/nautika/small_logo201608311147.jpg",
    "name": "Nautika",
    "url": "https://tienda.mercadolibre.cl/nautika"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/301312883/nerf/small_logo201804120508.jpg",
    "name": "Nerf",
    "url": "https://tienda.mercadolibre.cl/nerf"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/338419532/neumamerica/small_logo201808290317.jpg",
    "name": "Neumamerica",
    "url": "https://tienda.mercadolibre.cl/neumamerica"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/304879406/newera/small_logo201805150642.jpg",
    "name": "New Era",
    "url": "https://tienda.mercadolibre.cl/new-era"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/267954641/nikon/small_logo201708251155.jpg",
    "name": "Nikon",
    "url": "https://tienda.mercadolibre.cl/nikon"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/189332418/nipon/small_logo201808091115.jpg",
    "name": "Nipon",
    "url": "https://tienda.mercadolibre.cl/nipon"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/304879406/nixon/small_logo201803090941.jpg",
    "name": "Nixon",
    "url": "https://tienda.mercadolibre.cl/nixon"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/315984133/nova/small_logo201808060538.jpg",
    "name": "Nova",
    "url": "https://tienda.mercadolibre.cl/nova"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/189352352/ortopediasmasvida/small_logo201710060228.jpg",
    "name": "Ortopedias mas vida",
    "url": "https://tienda.mercadolibre.cl/ortopedias-mas-vida"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/225024072/oster/small_logo201608260517.jpg",
    "name": "Oster",
    "url": "https://tienda.mercadolibre.cl/oster"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/333570868/oxo/small_logo201807311058.jpg",
    "name": "OXO",
    "url": "https://tienda.mercadolibre.cl/oxo"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/226369160/pg/small_logo201705220317.jpg",
    "name": "P&G",
    "url": "https://tienda.mercadolibre.cl/pg"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/316471956/palmers/small_logo201808061226.jpg",
    "name": "Palmers",
    "url": "https://tienda.mercadolibre.cl/palmers"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/264136966/panasonic/small_logo201709070511.jpg",
    "name": "Panasonic",
    "url": "https://tienda.mercadolibre.cl/panasonic"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/225126657/pegperego/small_logo201803290246.jpg",
    "name": "Peg Perego",
    "url": "https://tienda.mercadolibre.cl/peg-perego"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/273151086/petronas/small_logo201709140301.jpg",
    "name": "Petronas",
    "url": "https://tienda.mercadolibre.cl/petronas"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/204808902/philips/small_logo201603170702.png",
    "name": "Philips",
    "url": "https://tienda.mercadolibre.cl/philips"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/336233859/pillin/small_logo201808290916.jpg",
    "name": "Pillin",
    "url": "https://tienda.mercadolibre.cl/pillin"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/256952732/pinypon/small_logo201709210958.jpg",
    "name": "Pinypon",
    "url": "https://tienda.mercadolibre.cl/pinypon"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/280022892/pirelli/small_logo201801170614.jpg",
    "name": "Pirelli",
    "url": "https://tienda.mercadolibre.cl/pirelli"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/192017450/piscineria/small_logo201609280537.jpg",
    "name": "Piscineria",
    "url": "https://tienda.mercadolibre.cl/piscineria"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/326946940/playbox/small_logo201807051129.jpg",
    "name": "Play Box",
    "url": "https://tienda.mercadolibre.cl/play-box"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/301312883/playdoh/small_logo201804120510.jpg",
    "name": "Play Doh",
    "url": "https://tienda.mercadolibre.cl/play-doh"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/256952732/playmobil/small_logo201709211008.jpg",
    "name": "Playmobil",
    "url": "https://tienda.mercadolibre.cl/playmobil"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/176035007/polar/small_logo201806140629.jpg",
    "name": "Polar",
    "url": "https://tienda.mercadolibre.cl/polar"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/271730605/pulso/small_logo201709200948.jpg",
    "name": "Pulso",
    "url": "https://tienda.mercadolibre.cl/pulso"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/277052057/rancho/small_logo201710101141.jpg",
    "name": "Rancho",
    "url": "https://tienda.mercadolibre.cl/rancho"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/256901399/rayban/small_logo201803261053.jpg",
    "name": "Ray-Ban",
    "url": "https://tienda.mercadolibre.cl/rayban"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/256901399/razer/small_logo201712140238.jpg",
    "name": "Razer",
    "url": "https://tienda.mercadolibre.cl/razer"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/200605913/rca/small_logo201807180547.jpg",
    "name": "RCA",
    "url": "https://tienda.mercadolibre.cl/rca"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/263314123/redbull/small_logo201707190329.jpg",
    "name": "Red Bull",
    "url": "https://tienda.mercadolibre.cl/red-bull"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/149421279/reifstore/small_logo201711290430.jpg",
    "name": "Reifstore",
    "url": "https://tienda.mercadolibre.cl/reifstore"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/226369160/remington/small_logo201610181139.jpg",
    "name": "Remington",
    "url": "https://tienda.mercadolibre.cl/remington"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/341065549/roda/small_logo201808281139.jpg",
    "name": "Roda",
    "url": "https://tienda.mercadolibre.cl/roda"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/219521585/roichen/small_logo201611151106.jpeg",
    "name": "Roichen",
    "url": "https://tienda.mercadolibre.cl/roichen"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/284447089/sallybeauty/small_logo201711211124.jpg",
    "name": "SALLYBEAUTY",
    "url": "https://tienda.mercadolibre.cl/sallybeauty"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/276224474/samsonite/small_logo201710061145.jpg",
    "name": "Samsonite",
    "url": "https://tienda.mercadolibre.cl/samsonite"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/256901399/sandisk/small_logo201705190314.jpg",
    "name": "Sandisk",
    "url": "https://tienda.mercadolibre.cl/sandisk"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/276224474/saxoline/small_logo201710061152.jpg",
    "name": "Saxoline",
    "url": "https://tienda.mercadolibre.cl/saxoline"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/228531702/scaldasonno/small_logo201610200359.jpg",
    "name": "Scaldasonno",
    "url": "https://tienda.mercadolibre.cl/scaldasonno"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/316689115/seagate/small_logo201805221231.jpg",
    "name": "Seagate",
    "url": "https://tienda.mercadolibre.cl/seagate"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/315168851/sebastianprofessional/small_logo201806151219.jpg",
    "name": "Sebastian Professional",
    "url": "https://tienda.mercadolibre.cl/sebastian-professional"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/276224474/secret/small_logo201801180226.jpg",
    "name": "Secret",
    "url": "https://tienda.mercadolibre.cl/secret"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/288881873/sennheiser/small_logo201801171238.jpg",
    "name": "Sennheiser",
    "url": "https://tienda.mercadolibre.cl/sennheiser"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/183578511/serviper/small_logo201709121116.jpg",
    "name": "Serviper",
    "url": "https://tienda.mercadolibre.cl/serviper"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/235618031/siegen/small_logo201701100218.jpg",
    "name": "Siegen",
    "url": "https://tienda.mercadolibre.cl/siegen"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/241232759/sigma/small_logo201703170226.png",
    "name": "Sigma",
    "url": "https://tienda.mercadolibre.cl/sigma"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/350110758/sindelen/small_logo201809061228.jpg",
    "name": "Sindelen",
    "url": "https://tienda.mercadolibre.cl/sindelen"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/216522279/skil/small_logo201709120132.jpg",
    "name": "Skil",
    "url": "https://tienda.mercadolibre.cl/skil"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/316471956/sloggi/small_logo201804251144.jpg",
    "name": "Sloggi",
    "url": "https://tienda.mercadolibre.cl/sloggi"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/284500286/somela/small_logo201711290944.jpg",
    "name": "Somela",
    "url": "https://tienda.mercadolibre.cl/somela"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/237931934/sonos/small_logo201808100513.jpg",
    "name": "Sonos",
    "url": "https://tienda.mercadolibre.cl/sonos"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/177969871/sony/small_logo201709080320.jpg",
    "name": "Sony",
    "url": "https://tienda.mercadolibre.cl/sony"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/304879406/stance/small_logo201805150644.jpg",
    "name": "Stance",
    "url": "https://tienda.mercadolibre.cl/stance"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/170130005/stanley/small_logo201708110429.jpg",
    "name": "Stanley",
    "url": "https://tienda.mercadolibre.cl/stanley"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/305373028/stellaartois/small_logo201803150500.jpg",
    "name": "Stella Artois",
    "url": "https://tienda.mercadolibre.cl/stella-artois"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/341065549/stokke/small_logo201808240955.jpg",
    "name": "Stokke",
    "url": "https://tienda.mercadolibre.cl/stokke"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/304879406/herschel/small_logo201807260458.jpg",
    "name": "Street Machine",
    "url": "https://tienda.mercadolibre.cl/street-machine"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/337990103/summerinfant/small_logo201807260559.jpg",
    "name": "Summer Infant",
    "url": "https://tienda.mercadolibre.cl/summer-infant"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/304879406/superga/small_logo201805150638.jpg",
    "name": "Superga",
    "url": "https://tienda.mercadolibre.cl/superga"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/280092967/supermercadodelneumtico/small_logo201711060445.jpg",
    "name": "Supermercado del Neumático",
    "url": "https://tienda.mercadolibre.cl/supermercado-del-neumatico"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/276252002/swatch/small_logo201710110223.jpg",
    "name": "Swatch",
    "url": "https://tienda.mercadolibre.cl/swatch"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/237547330/sxs/small_logo201701110547.jpg",
    "name": "SXS",
    "url": "https://tienda.mercadolibre.cl/sxs"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/278767979/tamron/small_logo201711031017.jpg",
    "name": "TAMRON",
    "url": "https://tienda.mercadolibre.cl/tamron"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/259865773/targus/small_logo201709211108.jpg",
    "name": "Targus",
    "url": "https://tienda.mercadolibre.cl/targus"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/200605913/tcl/small_logo201707141251.jpg",
    "name": "TCL",
    "url": "https://tienda.mercadolibre.cl/tcl"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/225778595/tefal/small_logo201807130505.jpg",
    "name": "Tefal",
    "url": "https://tienda.mercadolibre.cl/tefal"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/273176277/thefutbolstore/small_logo201711210245.jpg",
    "name": "The Futbol Store",
    "url": "https://tienda.mercadolibre.cl/the-futbol-store"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/330426443/thermos/small_logo201807260645.jpg",
    "name": "Thermos",
    "url": "https://tienda.mercadolibre.cl/thermos"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/235618031/thomas/small_logo201701100445.jpg",
    "name": "Thomas",
    "url": "https://tienda.mercadolibre.cl/thomas"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/279737632/thorben/small_logo201711030230.jpg",
    "name": "Thorben",
    "url": "https://tienda.mercadolibre.cl/thorben"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/237848105/thule/small_logo201709111000.jpg",
    "name": "Thule",
    "url": "https://tienda.mercadolibre.cl/thule"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/289837075/timex/small_logo201808271058.jpg",
    "name": "Timex",
    "url": "https://tienda.mercadolibre.cl/timex"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/349532972/toms/small_logo201809120306.jpg",
    "name": "TOMS",
    "url": "https://tienda.mercadolibre.cl/toms"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/209289169/topper/small_logo201709110957.jpg",
    "name": "Topper",
    "url": "https://tienda.mercadolibre.cl/topper"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/353188110/toyota/small_logo201809270551.jpg",
    "name": "Toyota",
    "url": "https://tienda.mercadolibre.cl/toyota"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/312708884/triumph/small_logo201804191127.jpg",
    "name": "Triumph",
    "url": "https://tienda.mercadolibre.cl/triumph"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/305330042/trust/small_logo201804240354.jpg",
    "name": "Trust",
    "url": "https://tienda.mercadolibre.cl/trust"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/333608061/universidadcatlica/small_logo201807190227.jpg",
    "name": "Universidad Católica",
    "url": "https://tienda.mercadolibre.cl/universidad-catolica"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/323921013/vielco/small_logo201808100407.jpg",
    "name": "Vielco",
    "url": "https://tienda.mercadolibre.cl/vielco"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/238578600/viewsonic/small_logo201707181251.jpg",
    "name": "Viewsonic",
    "url": "https://tienda.mercadolibre.cl/viewsonic"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/291424552/virginmobile/small_logo201801240241.jpg",
    "name": "Virgin Mobile",
    "url": "https://tienda.mercadolibre.cl/virgin-mobile"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/338419532/neumamerica/small_logo201808230604.jpg",
    "name": "Vredestein",
    "url": "https://tienda.mercadolibre.cl/vredestein"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/256901399/westerndigital/small_logo201706090617.jpg",
    "name": "Western Digital",
    "url": "https://tienda.mercadolibre.cl/western-digital"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/276224474/xtrem/small_logo201801220529.jpg",
    "name": "Xtrem",
    "url": "https://tienda.mercadolibre.cl/xtrem"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/226089284/yamahamoto/small_logo201610030531.jpg",
    "name": "Yamaimport",
    "url": "https://tienda.mercadolibre.cl/yamaimport"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/241232759/yongnuo/small_logo201702280446.png",
    "name": "Yongnuo",
    "url": "https://tienda.mercadolibre.cl/yongnuo"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/273047039/zippo/small_logo201709130429.jpg",
    "name": "Zippo",
    "url": "https://tienda.mercadolibre.cl/zippo"
  },
  {
    "logo": "https://http2.mlstatic.com/resources/largesellers/278942682/zsmotor/small_logo201711070301.jpg",
    "name": "ZS Motor",
    "url": "https://tienda.mercadolibre.cl/zs-motor"
  }
])